/**
 * PitchPrint Auto-Save Crash Fix
 *
 * Root cause discovered 2026-04-30 (Session 158):
 *
 * PitchPrint's parent client.js routes BOTH `project-saved` AND
 * `send-client-session` postMessages to `_onSave(t.value)` via the same
 * switch case. The auto-save flow fires `send-client-session` (NOT
 * `project-saved`), and that event payload is `{projectId, meta, source,
 * numPages, isvx, distiller}` — it carries NO `autoSaved` flag.
 *
 * Inside `_onSave`, the early-return guard `if (e.autoSaved) return;` is
 * therefore skipped, and `_addToCart()` fires on every 5-minute auto-save:
 *   1. _addToCart() schedules `setTimeout(() => cartButton.click(), 500)`
 *   2. Cart button click triggers PitchPrint's `n` handler attached by
 *      shopify.js's `m()` function (the `session-saved` event listener)
 *   3. That handler waits 1s then calls `m({data:{clear:true}})`
 *   4. `m()` with clear:true calls `window.location.reload()`
 *   5. Page navigates while iframe is mid-render → editor crashes
 *
 * Fix (surgical): monkey-patch `ppclient._onSave` to detect the
 * send-client-session payload shape (no `previews` array, no `autoSaved`
 * flag) and inject `autoSaved: true`. PitchPrint's existing autoSaved
 * early-return then kicks in naturally. The cascade is broken without
 * disabling any official config flags — the manual-approve auto-ATC
 * flow continues to work normally because manual-save payloads include
 * `previews` and aren't matched by the heuristic.
 */

(function () {
  'use strict';

  var log = function () {
    if (window.PITCHPRINT_DEBUG) {
      var args = ['[PP AutoSave Fix]'].concat(Array.prototype.slice.call(arguments));
      console.log.apply(console, args);
    }
  };

  function patchOnSave() {
    if (!window.ppclient || typeof window.ppclient._onSave !== 'function') return false;
    if (window.ppclient.__autosaveFixApplied) return true;

    var original = window.ppclient._onSave.bind(window.ppclient);
    window.ppclient._onSave = function (e) {
      // Auto-save (send-client-session) payload: {projectId, meta, source,
      // numPages, isvx, distiller}. Manual approve (project-saved) payload
      // includes `previews` array AND explicit `autoSaved: false`. If both
      // markers are missing, treat as auto-save.
      if (e && typeof e === 'object' && !('previews' in e) && !('autoSaved' in e)) {
        e.autoSaved = true;
        log('Detected send-client-session shape — marking autoSaved=true to skip _addToCart cascade', e);
      }
      return original(e);
    };
    window.ppclient.__autosaveFixApplied = true;
    log('ppclient._onSave patched');
    return true;
  }

  if (patchOnSave()) return;

  var attempts = 0;
  var interval = setInterval(function () {
    attempts++;
    if (patchOnSave() || attempts > 200) {
      clearInterval(interval);
    }
  }, 100);
})();
